import "./App.scss";
import React from "react";
import Map from "./components/MapWrap/MapWrap";
import { MapContextProvider } from "./context/MapContext";
import CalciteThemeProvider from "calcite-react/CalciteThemeProvider";
import ReactGA from 'react-ga';
import { environment } from "./constants/environment";

function App() {
  if(window.location.hostname.includes('maps.oceanwealth.org')) {
    ReactGA.initialize(environment.googleAnalyticsKey);
    ReactGA.pageview(window.location.pathname);
  }

  return (
    <div className="appWrap">
      <CalciteThemeProvider>
        <MapContextProvider>
          <Map />
        </MapContextProvider>
      </CalciteThemeProvider>
    </div>
  );
}

export default App;
